<template>
  <speech-and-language-annexes
    :full-profile="fullProfileData"
    :get-appointment-area="getAppointmentArea"
    :get-disciplines-for-therapy="getDisciplinesForTherapy"
    :get-goal-list="getGoalListsByUser"
    :get-objective-list="getObjectiveListsByUser"
    :save-appointment-area="saveAppointmentArea"
  />
</template>

<script>
import { SpeechAndLanguageAnnexes } from 'appointment-management';
import {
  saveAppointmentAreaWithGoalsAndObjectives as _saveAppointmentArea,
  getAppointmentAreaWithGoalsAndObjectives as _getAppointmentArea,
  getObjectiveListsByUser as _getObjectiveListsByUser,
  getGoalListsByUser as _getGoalListsByUser,
} from '@/modules/appointmentManagement/api.js';

import { getDisciplinesForTherapy as _getDisciplinesForTherapy } from '@/modules/shared/code.api.js';

import { name as userModuleName } from '@/modules/user/store';
import { mapGetters } from 'vuex';

export default {
  name: 'SpeechAndLanguageAnnexesWrapper',
  components: {
    SpeechAndLanguageAnnexes,
  },
  computed: {
    ...mapGetters(userModuleName, ['fullProfile']),
    fullProfileData() {
      return this.fullProfile;
    },
  },
  methods: {
    saveAppointmentArea(clientAppointmentId, params) {
      return _saveAppointmentArea(clientAppointmentId, params);
    },
    getAppointmentArea(clientAppointmentId) {
      return _getAppointmentArea(clientAppointmentId);
    },
    getDisciplinesForTherapy() {
      return _getDisciplinesForTherapy();
    },
    getObjectiveListsByUser() {
      return _getObjectiveListsByUser();
    },
    getGoalListsByUser() {
      return _getGoalListsByUser();
    },
  },
};
</script>
